import type { Quiz } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

export function queryQuizzes(clientId: string) {
  return query<Quiz>(
    DataTypeQuiz.Quiz,
    {
      'filter[client.id]': clientId,
      sort: 'title',
    },
    jsonApiOptions
  );
}
